// @flow
import React from 'react';
import { compose, mapProps } from 'recompose';
import QRCode from 'qrcode';

import CustomModalContent from '../../ui/views/custom-modal-content';
import withItemData from './withItemData';

class CanvasEl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataUrl: null
    };
    this.canvasRef = null;
    this.setCanvasRef = element => {
      this.canvasRef = element;
    };
  }
  componentDidMount() {
    const { id } = this.props.item;
    const qrUrl = `${document.location.origin}/items/${id}`;
    QRCode.toDataURL(qrUrl)
      .then(url => {
        this.setState({
          dataUrl: url
        });
      })
      .catch(error => {
        console.error('ther error is: ', error);
      });
  }
  render() {
    const { dataUrl } = this.state;
    return (
      dataUrl && (
        <img
          src={dataUrl}
          alt='QR Code'
          style={{ width: '100%', height: '100%' }}
        />
      )
    );
  }
}

const withPresentationProps = mapProps(({ item }) => {
  return {
    title: 'QR Code',
    content: <CanvasEl item={item} />
  };
});

export const enhance = compose(
  withItemData,
  withPresentationProps
);

export default enhance(CustomModalContent);



// WEBPACK FOOTER //
// ./src/services/item/QR.js